// DOCS : https://reactrouter.com/en/main/router-components/browser-router

import { lazyImport } from 'utils/lazy-import';

/**
 * Not Found Page
 */
const { NotFoundRoute } = lazyImport(() => import('routes/not-found'), 'NotFoundRoute');

/**
 * Login Page
 */
const { LoginRoute } = lazyImport(() => import('features/auth'), 'LoginRoute');

export const publicRoutes = [
    {
        path: '/login',
        element: <LoginRoute />,
    },
    {
        path: '/not-found',
        element: <NotFoundRoute />,
    },
    {
        path: '*',
        element: <NotFoundRoute />,
    },
];
